import { useEffect, useRef, useState } from "react";

const FLASH_STYLE_ID = "pnl-stats-flash-keyframes";
const FLASH_KEYFRAMES = `
@keyframes pnl-stats-flash-up {
  0%   { background-color: transparent; transform: translateY(0); }
  22%  { background-color: color-mix(in srgb, var(--color-cede-pnl-positive) 26%, transparent); transform: translateY(-1px); }
  100% { background-color: transparent; transform: translateY(0); }
}
@keyframes pnl-stats-flash-down {
  0%   { background-color: transparent; transform: translateY(0); }
  22%  { background-color: color-mix(in srgb, var(--color-cede-error) 26%, transparent); transform: translateY(1px); }
  100% { background-color: transparent; transform: translateY(0); }
}
@keyframes pnl-stats-glow {
  0%   { box-shadow: 0 0 0 0 transparent; }
  25%  { box-shadow: 0 0 14px 1px color-mix(in srgb, var(--accent) 35%, transparent); }
  100% { box-shadow: 0 0 0 0 transparent; }
}`;

export const VALUE_FLASH_DURATION_MS = 900;

export function useFlashKeyframes() {
  useEffect(() => {
    if (document.getElementById(FLASH_STYLE_ID)) return;
    const style = document.createElement("style");
    style.id = FLASH_STYLE_ID;
    style.textContent = FLASH_KEYFRAMES;
    document.head.appendChild(style);
  }, []);
}

/** Returns "up" | "down" | null for ~900ms after `value` changes by > epsilon. */
export function useValueFlash(value: number, epsilon = 0.001): "up" | "down" | null {
  const [flash, setFlash] = useState<"up" | "down" | null>(null);
  const prevRef = useRef<number | null>(null);

  useEffect(() => {
    const prev = prevRef.current;
    prevRef.current = value;
    if (prev == null || Math.abs(value - prev) < epsilon) return;
    const direction: "up" | "down" = value > prev ? "up" : "down";
    setFlash(direction);
    const id = setTimeout(() => setFlash(null), VALUE_FLASH_DURATION_MS);
    return () => clearTimeout(id);
  }, [value, epsilon]);

  return flash;
}
